"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var util_localization_1 = __importStar(require("@sport-thieme/util-localization"));
var core_1 = require("@material-ui/core");
var PagePreloader_1 = __importDefault(require("../PagePreloader"));
var __1 = require("..");
util_localization_1.default.addTranslations('de', {
    'Sorry, your browser does not support embedded videos.': 'Dein Browser unterstützt keine eingebettete Videos.',
    'An error occured': 'Es ist ein Fehler aufgetreten',
});
exports.default = react_1.forwardRef(function MediaPreview(_a, ref) {
    var _b = _a.type, type = _b === void 0 ? 'image' : _b, src = _a.src, _c = _a.alt, alt = _c === void 0 ? 'preview' : _c, _d = _a.open, open = _d === void 0 ? false : _d, onClose = _a.onClose, onError = _a.onError;
    var classes = useStyles();
    var _e = react_1.useState(type === 'image'), loading = _e[0], setLoading = _e[1];
    var _f = react_1.useState(false), loadingError = _f[0], setLoadingError = _f[1];
    if (onError === undefined) {
        onError = function () { return setLoadingError(true); };
    }
    return (jsx_runtime_1.jsx(__1.Modal, __assign({ withCloseButton: loading === false, open: open, onClose: onClose, className: classes.maxHeight, ref: ref }, { children: type === 'video' ? (jsx_runtime_1.jsxs("video", __assign({ controls: true, muted: true, autoPlay: true, className: classes.video }, { children: [jsx_runtime_1.jsx("source", { src: src }, void 0), util_localization_1.default.localize(templateObject_1 || (templateObject_1 = __makeTemplateObject(["Sorry, your browser does not support embedded videos."], ["Sorry, your browser does not support embedded videos."])))] }), void 0)) : (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [loading && jsx_runtime_1.jsx(PagePreloader_1.default, { fillContainer: true }, void 0),
                loadingError ? (jsx_runtime_1.jsx(__1.Alert, __assign({ severity: "error" }, { children: util_localization_1.localize(templateObject_2 || (templateObject_2 = __makeTemplateObject(["An error occured"], ["An error occured"]))) }), void 0)) : (jsx_runtime_1.jsx("img", { src: src, onLoad: function () { return setLoading(false); }, alt: alt, className: classes.maxHeight, onError: function (error) {
                        setLoading(false);
                        onError === null || onError === void 0 ? void 0 : onError(error);
                    } }, void 0))] }, void 0)) }), void 0));
});
var useStyles = core_1.makeStyles(function () { return ({
    maxHeight: {
        maxHeight: '80vh',
        maxWidth: '70vw',
    },
    video: {
        width: '100%',
        height: '100%',
    },
}); });
var templateObject_1, templateObject_2;
//# sourceMappingURL=MediaPreview.js.map